import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function OrganizationDetailsSettings() {
  useDocumentTitle('Organization Details')
  return (
    <div className="container mx-auto px-2 py-6 space-y-6">
      <h2 className="text-2xl font-bold">Organization Details</h2>
    </div>
  )
}
